export interface MultiLevelListItem {
  name: string;
  value: string;
  disabled?: boolean;
  textColor?: string;
  action?: Function;
  children?: MultiLevelListItem[];
  hasDivider?: boolean;
}

export enum MultiLevelListEvents {
  ITEM_CLICKED = 'item-clicked',
}
